import { DOCUMENTS_LIST_WIDTH_REDESIGN, DOCUMENTS_PANE_RAIL_WIDTH } from 'constants/documents';
import { mediaQuery } from 'constants/ui';

import { INSPECTOR_PANE_WIDTH } from './DocumentInspector/DocumentInspector.constants';

// 3-pane grid: tree | viewer | inspector.
// Middle column uses minmax(0, 1fr) — a bare 1fr resolves to minmax(auto, 1fr) which
// refuses to shrink below the viewer's content min-width (~840px), pushing the inspector
// off-screen at common window widths (≤1700px). minmax(0, 1fr) forces the minimum to 0
// so the track can shrink to whatever space remains after the fixed columns are placed.
//
// gridTemplateRows: minmax(0, 1fr) is the row-axis equivalent and just as load-bearing —
// with no row track set, the single implicit row auto-sizes to the TALLEST column's own
// content height instead of this container's own (flex-1-constrained) height. Each pane's
// internal overflowY:auto (DocumentInspector's tabContentStyles, etc.) then never gets a
// real height budget to scroll within — the excess just gets silently clipped by this
// container's own overflow:hidden instead of scrolling. minmax(0, 1fr) forces the row to
// the container's real height so nested overflow:auto panes actually scroll.
//
// Accepts collapse flags so the grid reacts to panel collapse without a full re-render.
export const documentsRedesignLayoutStyles = ({ isListCollapsed, isInspectorCollapsed }) => ({
  display: 'grid',
  gridTemplateColumns: `${
    isListCollapsed ? DOCUMENTS_PANE_RAIL_WIDTH : DOCUMENTS_LIST_WIDTH_REDESIGN
  }px minmax(0, 1fr) ${isInspectorCollapsed ? DOCUMENTS_PANE_RAIL_WIDTH : INSPECTOR_PANE_WIDTH}px`,
  gridTemplateRows: 'minmax(0, 1fr)',
  height: '100%',
  overflow: 'hidden',
  transition: 'grid-template-columns 200ms ease',
  [mediaQuery.mobile]: {
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
  },
});

// Applied to the DocumentView grid item in the redesign layout.
// min-width: 0 lets the flex-1 item shrink to the grid track boundary rather than
// expanding to its inner content's natural size. overflow: hidden contains the
// PDF viewer content (which can still scroll internally) within the column.
// documentViewContainer: minWidth 0 relaxes the hard 600px floor so the viewer
// renders at the actual column width (~430px at 1366px viewport) instead of forcing
// layout overflow.
export const viewerPaneRedesignInlineClasses = {
  documentViewWrapper: { minWidth: 0, overflow: 'hidden' },
  documentViewContainer: { minWidth: 0 },
};

export const inspectorStackingStyles = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  overflow: 'hidden',
};
